'use strict';

var _ = require('lodash');
var GridReadOnlyRuleModalDirective = function GridReadOnlyRuleModalDirective(SaveRuleService, SerializeRuleService, RuleListingTransformerFactory) {
  function transformRules(rules) {
    var ruleTransformer = new RuleListingTransformerFactory();
    var transformedRules = ruleTransformer.transform({
      domain: rules
    });
    return _.first(transformedRules);
  }
  function normalizeRuleId(ruleId) {
    ruleId = _.replace(ruleId, 'R_', '');
    return ruleId;
  }
  return {
    restrict: 'E',
    controller: 'GridReadOnlyRuleModalController',
    template: require('../templates/grid-read-only-rule-modal.html'),
    link: function link(scope) {
      scope.$on('read-only-rule:show', function (e, ruleId) {
        SaveRuleService.getRuleById(normalizeRuleId(ruleId)).then(transformRules).then(function (rule) {
          scope.selectedRule = SerializeRuleService.parseRule(rule);
          scope.$broadcast('rm-modal:show', 'rule-visualize');
        });
      });
    }
  };
};
GridReadOnlyRuleModalDirective.$inject = ['SaveRuleService', 'SerializeRuleService', 'RuleListingTransformerFactory'];
module.exports = GridReadOnlyRuleModalDirective;